import Cookies from 'js-cookie';
import axios from 'axios'
import {robloxHost, rootDomain, serverHost} from "@/js/config";

export const getBrowserForLog = () => {
    let UserAgent = navigator.userAgent.toLowerCase();
    let browserInfo = {};
    let browserArray = {
        Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1,
        Firefox: UserAgent.indexOf('firefox') > -1,
        Opera: UserAgent.indexOf('opera') > -1,
        Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') === -1,
        Edge: UserAgent.indexOf('edge') > -1,
        QQBrowser: /qqbrowser/.test(UserAgent),
        WeixinBrowser: /MicroMessenger/i.test(UserAgent)
    };

    for (let i in browserArray) {
        if (browserArray[i]) {
            let versions = '';
            if (i === 'IE') {
                versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
            } else if (i === 'Chrome') {
                for (let mt in navigator.mimeTypes) {
                    if (navigator.mimeTypes[mt]['type'] === 'application/360softmgrplugin') {
                        i = '360';
                    }
                }
                versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
            } else if (i === 'Firefox') {
                versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
            } else if (i === 'Opera') {
                versions = UserAgent.match(/opera\/([\d.]+)/)[1];
            } else if (i === 'Safari') {
                versions = UserAgent.match(/version\/([\d.]+)/)[1];
            } else if (i === 'Edge') {
                versions = UserAgent.match(/edge\/([\d.]+)/)[1];
            } else if (i === 'QQBrowser') {
                versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
            }
            browserInfo.type = i;
            browserInfo.versions = parseInt(versions);
        }
    }
    return browserInfo;
}

export const getOperationSys = () => {
    let OS = {};

    OS.type = navigator.platform;

    let u = navigator.userAgent;
    let osVersion = {
        'Windows': u.match(/^.*Windows NT ([\d.]+);.*$/)?.pop(),
        'Android': u.match(/^.*Android ([\d.]+);.*$/)?.pop(),
        'iOS': u.match(/^.*OS ([\d_]+) like.*$/)?.pop().replace(/_/g, '.'),
        'Debian': u.match(/^.*Debian\/([\d.]+).*$/)?.pop(),
        'Windows Phone': u.match(/^.*Windows Phone( OS)? ([\d.]+);.*$/)?.pop(),
        'Mac OS': u.match(/^.*Mac OS X ([\d_]+).*$/)?.pop().replace(/_/g, '.'),
        'WebOS': u.match(/^.*hpwOS\/([\d.]+);.*$/)
    };

    Object.getOwnPropertyNames(osVersion).forEach(key => {
        if (osVersion[key]) {
            OS.versions = osVersion[key];
        }
    });

    return OS;
}
export const getBrowser = () =>{
    let UserAgent = navigator.userAgent.toLowerCase();
    if (UserAgent.match(/(?:Edge|Edg|EdgiOS|EdgA)\/(\d+)/i)){
        return "Edge"
    }else if (UserAgent.match(/(?:Firefox|FxiOS)\/(\d+)/i)) {
        return "Firefox"
    }
    else{
        return "Chrome"
    }
}
export const clickLog = async (flag)=>{
    let browser = getBrowserForLog();
    if (typeof flag === "string"){
        if (flag && flag.startsWith('rokit_lp')){
            flag = getBrowser().toLowerCase()[0] + "_" + flag;
        }
        let os = getOperationSys();
        let data = {
            userId: Cookies.get('installed'),
            userOs: os.type + " " + os.versions,
            actionUrl: window.location.href,
            clickFlag: flag,
            page:'web',
            visitorId: Cookies.get('c_vid'),
            userBrowser: browser.type + " " + browser.versions,
            appVersion: Cookies.get('app_version'),
            actionTime: new Date().getTime() / 1000,
            appType: Cookies.get('app_type'),
            roKitRef: Cookies.get('roKitRef'),
        };
        axios.post(serverHost + 'v1/commonLog/action/click',data).then()
    }

}
export const sendActionLog = (flag, toStore=false)=>{
    if (window.location.href == 'https://www.rokit.gg/install-success' && toStore){
        window.open('https://www.roblox.com/home')
    }else if (toStore){
        let webbrowser = getBrowser()
        if (webbrowser == 'Firefox'){
            // window.location.href = 'https://cdn.rokit.gg/firefox-download/rokit-firefox-v1.1.9.xpi'
        }else if(webbrowser == 'Edge'){
            window.open('https://microsoftedge.microsoft.com/addons/detail/rokit-ultimate-roblox-w/mobmbpgijplhnkieeiadblagnkfeeobk')
        }else {
            window.open('https://chrome.google.com/webstore/detail/rokit-ultimate-roblox-web/flpcjinfcjhnjopmjmgmldnlgpdpideg')
        }
    }
    clickLog(flag).then()
}
export const sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
}

export const test = async (loginPage) => {
    while (true){
        if (Cookies.get('rokit-id-token')){
            loginPage.close()
            break
        }
        await sleep(2000)
    }
}

export const getCommonHeader = () => {
    let isInstallPlugin = Cookies.get("installed");
    let token = Cookies.get('rokit-id-token');
    let appVersion = Cookies.get('app_version');
    let appType = Cookies.get('app_type');
    let result = {
        'origin-page': 'web',
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': "Bearer " + token,
    };
    if(isInstallPlugin && isInstallPlugin !== 'false' && isInstallPlugin !== false){
        result['user-id'] = isInstallPlugin;
    }
    if (appVersion){
        // result['rokit-app-version-num'] = getVersionNumber(appVersion);
    }
    if (appType){
        result['rokit-app-type'] = appType;
    }
    return result;
}


export const uninstallLog = () => {
    let uninstallResult = {};
    let browser = getBrowserForLog()
    let userId = Cookies.get("installed")
    let visitorId = Cookies.get("c_vid")
    if (userId !== undefined){
        uninstallResult['visitorId'] = visitorId
        uninstallResult["userId"] = userId
        uninstallResult["appType"] = Cookies.get('app_type');
        uninstallResult["appVersion"] = Cookies.get('app_version');
        uninstallResult["actionTime"] = new Date().getTime() / 1000;
        uninstallResult["actionUrl"] =  window.location.href;
        uninstallResult["userBrowser"] = browser.type + " " + browser.versions;
        uninstallResult["userAgent"] = navigator.userAgent;
        uninstallResult["flag"] = "uninstall"
        axios.post(serverHost + 'v1/commonLog/action/appAction', uninstallResult).then();
    }
}
export const deleteCookie = () => {
    Cookies.remove("installed", {path: '/', domain: rootDomain})
    Cookies.remove('app_type', {path: '/', domain: rootDomain})
    Cookies.remove('app_version', {path: '/', domain: rootDomain})
}

export const getIsMobile = () => {
    let ua = navigator.userAgent;
    let clientKey = ['nokia', 'sony', 'ericsson', 'mot', 'samsung', 'htc', 'sgh', 'lg', 'sharp', 'sie-', 'philips',
        'panasonic', 'alcatel', 'lenovo', 'iphone', 'ipod', 'blackberry', 'meizu', 'android', 'netfront', 'symbian',
        'ucweb', 'windowsce', 'palm', 'operamini', 'operamobi', 'openwave', 'nexusone', 'cldc', 'midp', 'wap', 'mobile', 'windows phone'];
    if (new RegExp(/iPad/i).test(ua)){
        return false;
    }
    if (new RegExp(clientKey.join('|')).test(ua.toLowerCase())){
        return true;
    }
    return false;
}

export const getRobloxInfoByName = (userName) => {

    axios.get(robloxHost + 'search/users/results?keyword='+userName+'&maxRows=1&startIndex=0').then((response)=>{
        console.warn('response',response)
        return response
    }).catch(()=>{
        console.warn('getRobloxInfoByName() error')
        return ''
    });
}

export const addMoth = (d,m)=>{

    var ds=d.split('-'),_d=ds[2]-0;

    var nextM=new Date( ds[0],ds[1]-1+m+1, 0 );

    var max=nextM.getDate();

    d=new Date( ds[0],ds[1]-1+m,_d>max? max:_d );

    return d.toLocaleDateString().match(/\d+/g).join('-')

}